export default __webpack_public_path__ + "static/media/Project2.7bd9119e.png";